import _ from 'lodash';
import React from 'react';
import { useLogValue } from '~/hooks';
import app from '~/app';

class Config {
  constructor( data ) {
    this.loaded = !!data;
    this.data = data;
    if ( data ) normalizeMenu( data.menus );
  }
  has( key ) { return _.has( this.data, key ); }
  get( key, defaultValue ) { return _.get( this.data, key, defaultValue ); }
  set( key, value ) { return _.set( this.data, key, value ); }
  pick( ...keys ) { return _.pick( this.data, ...keys ); }
  at( ...keys ) { return _.at( this.data, ...keys ); }

  getter( prefix ) {
    return ( key, defaultValue ) => {
      return this.get( `${prefix}.${key}`, defaultValue );
    };
  }
}

const ConfigContext = React.createContext();

export function useConfig() {
  const context = React.useContext( ConfigContext );
  if ( ! context ) {
    throw new Error( `useConfig must be used within a ConfigProvider` );
  }
  return context;
}

export function ConfigProvider( props ) {
  const [ config, setConfig ] = React.useState( new Config() );

  React.useEffect( () => {
    app.service( 'config' ).get( 'mine' )
      .then( data => setConfig( new Config( data ) ) )
      .catch( error => setConfig( new Config( { error } ) ) );
  }, [] );

  useLogValue( 'CONFIG', config );

  return <ConfigContext.Provider value={config} {...props} />;
}

export function useStation() {
  const context = React.useContext( ConfigContext );
  if ( ! context ) {
    throw new Error( `useStation must be used within a ConfigProvider` );
  }
  return context.get( 'station' );
}

function normalizeMenu( menu ) {
  if ( _.isArray( menu ) ) {
    return _.map( menu, ( item, idx ) => {
      if ( _.isString( item ) ) {
        if ( /^-+$/u.test( item ) ) {
          return { divider : true, label : `divider${idx}` };
        }
      } else if ( _.isPlainObject( item ) ) {
        return normalizeMenu( item );
      } else {
        throw new Error( `Invalid menu item "${item}"` );
      }
    } );
  } else if ( _.isPlainObject( menu ) ) {
    return _.mapValues( menu, ( val, key ) => {
      if ( key === 'items' && _.isArray( val ) ) return normalizeMenu( val );
      return val;
    } );
  } else {
    throw new Error( `Invalid menu "${menu}"` );
  }
}

